import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HTMLAttributes, ReactNode } from "react";

import { ProductPriceFragment } from "../../apiHooks/graphql";
import { ProductGuidePriceType } from "../../apiHooks/useProduct";
import { MarketPlaceMinPrice } from "../../components/MarketPlaceMinPrice";
import { TypographyBase } from "../../components/Typography";
import { Price as PriceType } from "../../types/Price";
import { Wrapper, TitleWrapper, PriceAndAvailability } from "./ProductHeaderV2LayoutComponents";
import { ProductInfoTagsV2 } from "./ProductTagsV2";

export const Title = styled(TypographyBase)(({ theme }) => ({
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    lineHeight: 1.4,
    fontSize: 24,
    [theme.breakpoints.up("lg")]: {
        WebkitLineClamp: 1,
        fontSize: 32,
    },
}));

export type ProductHeaderV2Props = {
    title: string;
    minPrice?: PriceType;
    hasFreeCancellation?: boolean;
    guidePriceFormattedText?: string;
    guidePriceType?: ProductGuidePriceType;
    availability?: ReactNode | null;
    guidePricePricingData?: ProductPriceFragment["pricingData"];
    productRatingComponent: React.ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export function ProductHeaderV2(props: ProductHeaderV2Props) {
    const {
        title,
        minPrice,
        hasFreeCancellation,
        guidePriceType,
        availability,
        guidePricePricingData,
        productRatingComponent,
        ...restProps
    } = props;
    const hasPrice = (minPrice?.amount ?? 0) > 0;
    return (
        <Wrapper {...restProps}>
            <TitleWrapper>
                <Title data-testid="title">{title}</Title>
                <Box display="flex" flexDirection="column" gap={0.5}>
                    <ProductInfoTagsV2 hasFreeCancellation={hasFreeCancellation} />
                    {productRatingComponent}
                </Box>
            </TitleWrapper>
            <PriceAndAvailability>
                {availability}
                {minPrice && hasPrice && (
                    <MarketPlaceMinPrice
                        data-testid="market-place-min-price"
                        priceType={guidePriceType ?? undefined}
                        minPrice={minPrice}
                        layout="horizontal"
                        guidePricePricingData={guidePricePricingData}
                    />
                )}
            </PriceAndAvailability>
        </Wrapper>
    );
}
